const searchSVG = (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 30.313 29.328'
		width='18'
		height='18'>
		<g
			id='Group_38596'
			data-name='Group 38596'
			transform='translate(0.246 -0.094)'>
			<rect
				id='Rectangle_34092'
				data-name='Rectangle 34092'
				width='30'
				height='29'
				transform='translate(-0.246 0.094)'
				fill='none'
			/>
			<g
				id='Icon_feather-search'
				data-name='Icon feather-search'
				transform='translate(2.948 2.303)'>
				<path
					id='Path_14365'
					data-name='Path 14365'
					d='M26.091,15.3A10.8,10.8,0,1,1,15.3,4.5,10.8,10.8,0,0,1,26.091,15.3Z'
					transform='translate(-4.5 -4.5)'
					fill='none'
					stroke='#ffffff'
					strokeWidth='4'
				/>
				<path
					id='Path_14366'
					data-name='Path 14366'
					d='M30.845,30.845l-5.87-5.87'
					transform='translate(-6.555 -6.555)'
					fill='none'
					stroke='#ffffff'
					strokeLinecap='round'
					strokeWidth='4'
				/>
			</g>
		</g>
	</svg>
);

export { searchSVG };
